import type { RunwayLayout } from './types'

export const DEFAULT_RUNWAY_LAYOUTS: Readonly<Record<string, RunwayLayout>> = {
    HEL: {
        modes: ['arrival', 'departure', 'conditional'],
        runways: [
            {
                ends: ['22R', '04L'],
                from: {
                    x: 146.7,
                    y: 61,
                },
                to: {
                    x: 18.3,
                    y: 216,
                },
                width: 25.4,
                outline: 'M130.47 61 L2.13 216 L34.53 216 L162.87 61 L130.47 61 Z',
            },
            {
                ends: ['15', '33'],
                from: {
                    x: 186.7,
                    y: 61,
                },
                to: {
                    x: 295.3,
                    y: 216,
                },
                width: 25.9,
                outline: 'M170.92 61 L279.52 216 L311.08 216 L202.48 61 L170.92 61 Z',
            },
            {
                ends: ['22L', '04R'],
                from: {
                    x: 252.7,
                    y: 61,
                },
                to: {
                    x: 124.3,
                    y: 216,
                },
                width: 25.4,
                outline: 'M236.47 61 L108.13 216 L140.53 216 L268.87 61 L236.47 61 Z',
            },
        ],
    },
    TLL: {
        modes: ['departure'],
        runways: [
            {
                ends: ['08', '26'],
                from: {
                    x: 30.8,
                    y: 34.4,
                },
                to: {
                    x: 369.7,
                    y: 34.4,
                },
                width: 69.2,
                outline:
                    'M32.28 8.46 L41.98 8.46 C42.11 8.46 42.25 8.48 42.37 8.5 L48.7 9.77 C49.28 9.89 49.77 10.25 50.05 10.77 L52.34 14.97 C52.5 15.26 52.58 15.59 52.58 15.92 L52.58 24.85 C52.58 25.47 52.29 26.06 51.79 26.43 L50.81 27.17 C50.67 27.27 50.52 27.36 50.35 27.42 L48.48 28.18 C48.24 28.27 47.99 28.32 47.74 28.32 L33.27 28.32 C32.72 28.32 32.28 28.76 32.28 29.31 C32.28 29.86 32.72 30.3 33.27 30.3 L47 30.3 C47.7 30.3 48.34 30.67 48.7 31.27 L49.33 32.31 C49.51 32.62 49.61 32.98 49.61 33.33 L49.61 35.11 C49.61 36.17 50.03 37.17 50.77 37.92 L56.46 43.62 C56.83 43.99 57.04 44.5 57.04 45.02 L57.04 50.64 L265.51 50.64 C266.61 50.64 267.49 51.53 267.49 52.63 L267.49 68.03 C267.49 68.58 267.94 69.02 268.49 69.02 L270.46 69.02 C271.01 69.02 271.46 68.58 271.46 68.03 L271.46 67.04 C271.46 66.49 271.9 66.04 272.45 66.04 L351.18 66.04 C352.27 66.04 353.16 65.15 353.16 64.06 L353.16 50.97 C353.16 50.18 353.64 49.46 354.36 49.15 L358.86 47.21 C359.67 46.87 360.37 46.31 360.9 45.61 C361.35 45.01 361.66 44.32 361.8 43.58 L361.93 42.97 C362.03 42.47 362.08 41.96 362.08 41.45 L362.08 41.26 C362.08 39.61 362.5 37.99 363.3 36.54 L364.32 34.7 C364.47 34.42 364.69 34.18 364.95 34.01 L365.75 33.48 C366.92 32.69 367.91 31.67 368.65 30.48 L369.69 28.81 C369.88 28.51 369.87 28.13 369.68 27.84 C369.35 27.34 368.62 27.3 368.24 27.77 L366.05 30.46 C365.29 31.39 363.86 31.36 363.14 30.4 L362.54 29.6 C361.91 28.76 361.07 28.11 360.1 27.72 L360.02 27.69 C359.42 27.45 358.77 27.33 358.11 27.33 L357.75 27.33 C356.36 27.33 354.98 27.62 353.71 28.18 L351.57 29.14 C351.31 29.25 351.04 29.31 350.76 29.31 L180.1 29.31 C179.14 29.31 178.36 28.53 178.36 27.57 C178.36 26.61 179.14 25.84 180.1 25.84 L205.34 25.84 C206.03 25.84 206.59 25.28 206.59 24.6 C206.59 23.91 206.03 23.35 205.34 23.35 L164.25 23.35 C163.56 23.35 163.01 23.91 163.01 24.6 C163.01 25.28 163.56 25.84 164.25 25.84 L170.18 25.84 C171.14 25.84 171.92 26.61 171.92 27.57 C171.92 28.53 171.14 29.31 170.18 29.31 L161.53 29.31 C160.43 29.31 159.54 28.42 159.54 27.33 L159.54 26.33 C159.54 25.24 158.65 24.35 157.56 24.35 L155.83 24.35 C155.42 24.35 155.08 24.68 155.08 25.09 C155.08 25.5 155.42 25.84 155.83 25.84 L156.32 25.84 C157.01 25.84 157.56 26.39 157.56 27.07 L157.56 27.57 C157.56 28.53 156.78 29.31 155.82 29.31 L153.6 29.31 C152.51 29.31 151.62 28.42 151.62 27.33 L151.62 22.36 C151.62 21.81 151.18 21.37 150.63 21.37 C150.08 21.37 149.64 21.81 149.64 22.36 L149.64 27.33 C149.64 28.42 148.75 29.31 147.65 29.31 L87.74 29.31 C86.65 29.31 85.76 28.42 85.76 27.33 L85.76 10.95 C85.76 9.85 86.65 8.96 87.74 8.96 L93.18 8.96 C94.28 8.96 95.17 9.85 95.17 10.95 L95.17 23.36 C95.17 23.9 95.61 24.35 96.16 24.35 C96.7 24.35 97.15 23.9 97.15 23.36 L97.15 19.88 C97.15 18.78 98.04 17.89 99.13 17.89 L101.11 17.89 C101.38 17.89 101.6 17.67 101.6 17.4 L101.6 15.91 C101.6 15.63 101.38 15.41 101.11 15.41 L99.62 15.41 L99.13 15.41 C98.04 15.41 97.15 14.52 97.15 13.43 L97.15 8.96 C97.15 7.86 96.26 6.97 95.16 6.97 L86.95 6.97 C86.5 6.97 86.06 6.82 85.71 6.54 L84.32 5.43 C83.97 5.14 83.53 4.99 83.08 4.99 L79.97 4.99 C79.55 4.99 79.14 4.85 78.8 4.6 L72.85 0.24 C72.32 -0.16 71.57 -0.04 71.18 0.48 C70.76 1.04 70.9 1.84 71.49 2.21 L78.33 6.65 C78.65 6.86 79.03 6.97 79.41 6.97 L82.58 6.97 C83.03 6.97 83.46 7.15 83.78 7.47 C84.09 7.79 84.27 8.22 84.27 8.67 L84.27 12.43 C84.27 13.53 83.38 14.42 82.29 14.42 L55.62 14.42 C54.96 14.42 54.34 14.09 53.97 13.53 L51.03 9.12 C50.75 8.7 50.33 8.4 49.84 8.28 L42.41 6.53 C42.26 6.5 42.1 6.48 41.95 6.48 L31.78 6.48 C31.24 6.48 30.79 6.92 30.79 7.47 C30.79 8.02 31.24 8.46 31.78 8.46 L32.28 8.46 Z M54.56 20.38 L54.56 25.34 C54.56 27.53 56.34 29.31 58.53 29.31 L80.3 29.31 C82.49 29.31 84.27 27.53 84.27 25.34 L84.27 20.38 C84.27 18.18 82.49 16.41 80.3 16.41 L58.53 16.41 C56.34 16.41 54.56 18.18 54.56 20.38 Z M51.59 34.77 L51.59 35.35 C51.59 35.62 51.69 35.87 51.88 36.05 L59.72 43.91 C59.9 44.1 60.16 44.2 60.42 44.2 L85.97 44.2 C86.21 44.2 86.32 43.9 86.13 43.75 C84.95 42.78 84.27 41.33 84.27 39.81 L84.27 35.76 C84.27 33.57 82.49 31.79 80.3 31.79 L54.57 31.79 C52.92 31.79 51.59 33.13 51.59 34.77 Z M86.25 40.23 L86.25 35.76 C86.25 33.57 88.03 31.79 90.22 31.79 L114.47 31.79 C116.66 31.79 118.44 33.57 118.44 35.76 L118.44 40.23 C118.44 42.42 116.66 44.2 114.47 44.2 L90.22 44.2 C88.03 44.2 86.25 42.42 86.25 40.23 Z M120.42 35.76 L120.42 40.23 C120.42 42.42 122.2 44.2 124.39 44.2 L152.75 44.2 C153.77 44.2 154.13 42.84 153.23 42.34 L136.54 33.05 C135.06 32.22 133.4 31.79 131.71 31.79 L124.39 31.79 C122.2 31.79 120.42 33.57 120.42 35.76 Z M158.71 42.85 L142.91 33.64 C142.03 33.13 142.39 31.79 143.41 31.79 L264.02 31.79 C266.21 31.79 267.99 33.57 267.99 35.76 L267.99 40.23 C267.99 42.42 266.21 44.2 264.02 44.2 L163.71 44.2 C161.95 44.2 160.23 43.74 158.71 42.85 Z M271.46 35.76 L271.46 40.23 C271.46 42.42 273.23 44.2 275.43 44.2 L347.21 44.2 C349.4 44.2 351.18 42.42 351.18 40.23 L351.18 35.76 C351.18 33.57 349.4 31.79 347.21 31.79 L275.43 31.79 C273.23 31.79 271.46 33.57 271.46 35.76 Z M271.46 59.09 L271.46 54.62 C271.46 52.43 273.23 50.65 275.43 50.65 L347.21 50.65 C349.4 50.65 351.18 52.43 351.18 54.62 L351.18 59.09 C351.18 61.29 349.4 63.06 347.21 63.06 L275.43 63.06 C273.23 63.06 271.46 61.29 271.46 59.09 Z M362.07 31.64 L360.83 30.05 C359.8 28.71 358.03 28.18 356.44 28.71 L356.2 28.79 C356.16 28.81 356.11 28.83 356.07 28.85 L353.94 29.92 C353.68 30.04 353.73 30.42 354.01 30.47 L358.12 31.3 L361.77 32.11 C362.04 32.17 362.24 31.86 362.07 31.64 Z M359.6 34.28 L358.98 33.34 C358.84 33.13 359.01 32.84 359.27 32.88 L361.84 33.25 C361.99 33.27 362.12 33.36 362.18 33.5 C362.63 34.39 362.1 35.46 361.13 35.66 L360.92 35.7 C360.72 35.74 360.52 35.65 360.4 35.48 L359.6 34.28 Z M351.57 31.97 L351.86 32.49 C352.71 33.98 353.16 35.68 353.16 37.4 L353.16 40.98 L353.16 46.24 C353.16 46.94 353.86 47.42 354.51 47.17 L355.55 46.78 C356.58 46.39 357.49 45.73 358.18 44.87 C358.79 44.1 359.21 43.21 359.4 42.25 L359.46 41.94 C359.55 41.46 359.6 40.98 359.6 40.49 L359.6 40.06 C359.6 39.51 359.56 38.97 359.47 38.43 L359.33 37.59 C359.18 36.71 358.9 35.85 358.5 35.05 L358.16 34.37 C357.81 33.65 357.29 33.02 356.67 32.52 C355.68 31.73 354.45 31.3 353.19 31.3 L351.96 31.3 C351.61 31.3 351.4 31.67 351.57 31.97 Z',
            },
        ],
    },
    TAY: {
        modes: ['departure'],
        runways: [
            {
                ends: ['08', '26'],
                from: {
                    x: 50,
                    y: 42,
                },
                to: {
                    x: 348,
                    y: 42,
                },
                width: 24,
            },
        ],
    },
    EPU: {
        modes: ['departure'],
        runways: [
            {
                ends: ['21', '03'],
                from: {
                    x: 236.9,
                    y: 60.8,
                },
                to: {
                    x: 77,
                    y: 221.3,
                },
                width: 24,
                outline:
                    'M60.28 221.28 L220.2 60.8 L253.59 60.8 L168.93 145.73 L93.66 221.28 L60.28 221.28 Z',
            },
        ],
    },
    KDL: {
        modes: ['departure'],
        runways: [
            {
                ends: ['14', '32'],
                from: {
                    x: 77,
                    y: 60.8,
                },
                to: {
                    x: 236.9,
                    y: 221.3,
                },
                width: 24,
                outline:
                    'M253.59 221.28 L93.66 60.8 L60.28 60.8 L144.93 145.73 L220.2 221.28 L253.59 221.28 Z',
            },
        ],
    },
    URE: {
        modes: ['departure'],
        runways: [
            {
                ends: ['23', '05'],
                from: {
                    x: 236.9,
                    y: 60.8,
                },
                to: {
                    x: 77,
                    y: 221.3,
                },
                width: 24,
                outline:
                    'M60.28 221.28 L220.2 60.8 L253.59 60.8 L168.93 145.73 L93.66 221.28 L60.28 221.28 Z',
            },
            {
                ends: ['17', '35'],
                from: {
                    x: 162,
                    y: 60,
                },
                to: {
                    x: 162,
                    y: 220,
                },
                width: 24,
            },
        ],
    },
    ARN: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        labelDistance: 18,
        arrowsAlongRunway: true,
        runways: [
            {
                ends: ['01L', '19R'],
                from: {
                    x: 23.85,
                    y: 224.64,
                },
                to: {
                    x: 54.41,
                    y: 51.32,
                },
                width: 18,
            },
            {
                ends: ['08', '26'],
                from: {
                    x: 139.49,
                    y: 68.81,
                },
                to: {
                    x: 310.27,
                    y: 26.23,
                },
                width: 18,
            },
            {
                ends: ['01R', '19L'],
                from: {
                    x: 151.81,
                    y: 321.6,
                },
                to: {
                    x: 182.37,
                    y: 148.28,
                },
                width: 18,
            },
        ],
    },
    GOT: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['03', '21'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    BMA: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['12', '30'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    MMX: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['17', '35'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    LLA: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['14', '32'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    UME: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['14', '32'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    VBY: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['03', '21'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    OSD: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['12', '30'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    KRN: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['04', '22'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
    RNB: {
        modes: ['arrival', 'departure'],
        palette: {
            runway: 'silver',
            departure: 'indigo',
        },
        runways: [
            {
                ends: ['01', '19'],
                from: {
                    x: 30,
                    y: 12,
                },
                to: {
                    x: 328,
                    y: 12,
                },
                width: 24,
            },
        ],
    },
}
